export function SpinnerLoader(){
    return (<div className="inline-block align-bottom"><div className="lds-ring"><div></div><div></div><div></div><div></div></div></div>);
}
export function EllipsisLoader(){
    return (<div className="inline-block align-bottom"><div className="lds-ellipsis"><div></div><div></div><div></div><div></div></div></div>);
}